import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeopleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#aeaeae",
	viewBox: "0 0 128 72",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M36 0a24 24 0 0 0-24 24 24 24 0 0 0 48 0A24 24 0 0 0 36 0v8a16 16 0 0 1 16 16 16 16 0 0 1-32 0A16 16 0 0 1 36 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 72a32 32 0 1 1 64 0h-8a24 24 0 1 0-48 0ZM92 0a24 24 0 0 0-24 24 24 24 0 0 0 48 0A24 24 0 0 0 92 0v8a16 16 0 0 1 16 16 16 16 0 0 1-32 0A16 16 0 0 1 92 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M60 72a32 32 0 1 1 64 0h-8a24 24 0 1 0-48 0Z" })
	]
});
export default SvgPeopleIcon;
